/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import AbstractButton from './AbstractButton';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { translate } from 'store/modules/base/i18n/functions';
import { connect } from 'store/modules/base/redux/functions';
import { WhiteboardIcon } from 'assets/images';
import { toggleWhiteboard } from 'store/modules/whiteboard/actions';
import { isWhiteboardVisible } from 'store/modules/whiteboard/functions';
import {
  registerShortcut,
  unregisterShortcut
} from 'store/modules/keyboard-shortcuts/actions';

/**
 * Component that renders a toolbar button for the whiteboard.
 */
class WhiteboardButton extends AbstractButton {
  accessibilityLabel = 'toolbar.accessibilityLabel.whiteboard';
  icon = WhiteboardIcon;
  label = 'toolbar.showWhiteboard';
  toggledLabel = 'toolbar.hideWhiteboard';
  type = 'blue';

  // toggledTooltip = 'toolbar.hideWhiteboard';
  // tooltip = 'toolbar.showWhiteboard';

  /**
   * Initializes a new {@code AudioSettingsButton} instance.
   *
   * @inheritdoc
   */
  constructor(props) {
    super(props);

    // Bind event handlers so they are only bound once per instance.
    this._onKeyboardShortcut = this._onKeyboardShortcut.bind(this);
  }

  /**
   * Registers the keyboard shortcut that toggles the audio muting.
   *
   * @inheritdoc
   * @returns {void}
   */
  componentDidMount() {
    this.props.dispatch(
      registerShortcut({
        character: 'W',
        helpDescription: 'keyboardShortcuts.whiteboard',
        handler: this._onKeyboardShortcut
      })
    );
  }

  /**
   * Unregisters the keyboard shortcut that toggles the audio muting.
   *
   * @inheritdoc
   * @returns {void}
   */
  componentWillUnmount() {
    this.props.dispatch(unregisterShortcut('W'));
  }

  /**
   * Creates an analytics keyboard shortcut event and dispatches an action to
   * toggle the audio muting.
   *
   * @private
   * @returns {void}
   */
  _onKeyboardShortcut() {
    // Ignore keyboard shortcuts if the audio button is disabled.
    if (this._isDisabled()) {
      return;
    }

    AbstractButton.prototype._onClick.call(this);
  }

  /**
   * Handles clicking / pressing the button, and opens / closes the whiteboard view.
   *
   * @private
   * @returns {void}
   */
  _handleClick() {
    this.props.dispatch(toggleWhiteboard());
  }

  /**
   * Indicates whether this button is in toggled state or not.
   *
   * @override
   * @protected
   * @returns {boolean}
   */
  _isToggled() {
    return this.props._toggled;
  }
}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
  return {
    _toggled: isWhiteboardVisible(state),
    _userIdleMode: state['features/settings'].userIdleMode
  };
}

WhiteboardButton.propTypes = {
  /**
   * Whether or not the button is toggled.
   */
  _toggled: PropTypes.bool,
  showLabel: PropTypes.bool,
  localParticipant: PropTypes.object,
  /**
   * The redux {@code dispatch} function.
   */
  dispatch: PropTypes.func
};
export default React.memo(
  translate(connect(_mapStateToProps)(withBoundary(WhiteboardButton)))
);
